import { CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js'

export function cognitoSignUp(cognitoUserPool, cognitoStorage, email, password) {
  return new Promise((resolve, reject) => {
    console.log('cognitoSignUp')
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email,
      })
    ]

    cognitoUserPool.signUp(email, password, attributeList, null, err => {
      if (err) {
        console.error('signUp err', JSON.stringify(err))
        const code = err.code || ''
        if (code === 'UsernameExistsException') {
          resendSignUpToken(cognitoUserPool, cognitoStorage, email, reject, resolve)
        } else if (code === 'InvalidParameterException') {
          reject('The password does not meet the minimum requirements. Choose a password with at least 8 characters.')
        } else {
          reject('Error creating the account! ' + err.message + ' (' + err.code + ')')
        }
      } else {
        console.log('signUp success')
        resolve()
      }
    })
  })
}

export function resendSignUpToken(cognitoUserPool, cognitoStorage, email, reject, resolve) {
  console.log('resendSignUpToken')
  const userData = {
    Username: email,
    Pool: cognitoUserPool,
    Storage: cognitoStorage
  }

  const user = new CognitoUser(userData)
  user.resendConfirmationCode((err, res) => {
    if (err) {
      console.error('resendConfirmationCode err', err)
      if (err.code === 'LimitExceededException') {
        reject('Attempt limit exceeded, please try again after some time.')
      } else {
        reject('Oops! Looks like this user account already exists. Please login to continue.')
      }
    } else {
      console.log('resendConfirmationCode res', res)
      resolve()
    }
  })
}

export function submitConfirmationToken(cognitoUserPool, cognitoStorage, email, token) {
  return new Promise((resolve, reject) => {
    console.log('submitConfirmationToken', cognitoStorage)
    const userData = {
      Username: email,
      Pool: cognitoUserPool,
      Storage: cognitoStorage
    }
    let user
    try {
      user = new CognitoUser(userData)
    } catch(err) {
      console.error(err)
      return
    }

    console.log('confirmRegistration email [%s] secret [%s]', email, token)
    user.confirmRegistration(token, false, (err, result) => {
      if (!err) {
        console.log('confirmRegistration result [%s]', result)
        resolve()
        //that.changeView('login')
        //that.processLogin()
      } else {
        console.error('confirmRegistration result [%s] err', result, JSON.stringify(err))
        const code = err.code || ''
        if (code === 'CodeMismatchException') {
          reject('Verification failed. Either the token is not correct or it has been already used. Please check the token value.')
        } else if (code === 'InvalidParameterException') {
          reject('Verification failed. Either the token is not correct or it has been already used. Please check the token value.')
        } else {
          reject('Verification failed. ' + err.message + ' (' + code + ')')
        }
      }
    })
  })
}

export function processLogin(cognitoUserPool, cognitoStorage, email, password) {
  return new Promise((resolve, reject) => {
    console.log('processLogin email [%s] password [%s]', email, password.replace(/./g, '*'))
    const userData = {
      Username: email,
      Pool: cognitoUserPool,
      Storage: cognitoStorage
    }
    const authDetails = new AuthenticationDetails({
      Username: email,
      Password: password
    })
    const user = new CognitoUser(userData)

    user.authenticateUser(authDetails, {
      onSuccess(result) {
        console.log('authenticateUser success', result)
        resolve('after-login')
      },
      onFailure(err) {
        console.error('authenticateUser err', JSON.stringify(err))
        if (err.code === 'UserNotConfirmedException') {
          resolve('secret')
        } else {
          reject(err.message)
        }
      }
    })
  })
}

export function deleteUser(cognitoUserPool, cognitoStorage, email) {

  let userData = {
    Username : email,
    Pool : cognitoUserPool,
    Storage: cognitoStorage
  }

  const user = new CognitoUser(userData)
  user.deleteUser(function(err, result) {
      if(err) {
          alert(err)
          return
      }
      console.log('call result: ' + result)
  })
}



// WEBPACK FOOTER //
// ./src/utils/PfxCognitoFunctions.js